export default {
  namespaced: true,
  state: {
    allCountries: {},
  },
  mutations: {
    setAllCountries: function (state, allCountries) {
      state.allCountries = allCountries;
    },
  },
};
